import PictureFrame from '../pictureFrame/PictureFrame';
import Plug from '../plug/Plug';

function Movie({ movie, onSelectMovie, onScroll, mediaQuery }) {
  function handlerClick() {
    onSelectMovie(movie.imdbID);
    if (mediaQuery.matches) {
      onScroll();
    }
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') {
      onSelectMovie(movie.imdbID);
    }
  }

  return (
    <li onClick={handlerClick} onKeyDown={handleKeyDown} tabIndex='0'>
      <div className='img-holder'>
        {movie.Poster !== 'N/A' ? (
          <PictureFrame>
            <img src={movie.Poster} alt={`${movie.Title} poster`} />
          </PictureFrame>
        ) : (
          <Plug>{`${movie.Poster}`}</Plug>
        )}
      </div>
      <h3>{movie.Title}</h3>
      <div className='date'>
        <p>
          <span>🗓</span>
          <span>{movie.Year}</span>
        </p>
      </div>
    </li>
  );
}

export default Movie;
